<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="selectedRows.length == 0"
        class="btn primary small outline"
        @click="deleteCurrency"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="selectedRows.length == 0"
        class="btn primary small"
        @click="editCurrency"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
      <button class="btn primary small" @click="downloadExcel">
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleCurrencyUpdate')
          : $t('dialog.titleCurrencyAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Mã tiền tệ">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.currencyCode') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="currencyItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.decimalDigit') }}:</div>
                  <el-select
                    v-model="currencyItem.decimal_digit"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in decimalDigitOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Tên đơn vị tiền tệ"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.currencyName') }}:
                    </div>
                    <div class="child-w-80">
                      <input v-model="currencyItem.currency_unit" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="integer|number" name="Tỷ giá">
                  <div class="das-form-input">
                    <div class="label">{{ $t('dialog.exchangeRate') }}:</div>
                    <div class="child-w-80">
                      <input
                        v-model="currencyItem.exchange_rate"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row align-end">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="integer|number"
                  name="Tỷ giá hối đoái khoản nợ trả chậm"
                >
                  <div class="das-form-input">
                    <div class="label">
                      {{ $t('dialog.exchangeRateDebit') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="currencyItem.exchange_rate_debit"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="currencyItem.basis"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3">{{ $t('dialog.basis') }}</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp4"
                      v-model="currencyItem.devide_basis"
                      type="checkbox"
                    />
                    <label for="cpSpdTp4">{{ $t('dialog.devideBasis') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateCurrency"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addCurrency">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import { downloadFile } from '@/utils/file-handler'
import {
  getListCurrencyApi,
  addCurrencyApi,
  updateCurrencyApi,
  deleteCurrencyApi,
  getMaterialCurrencyListApi
} from '@/api/configuration/accounting/currency.js'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      selectedRows: [],
      loading: false,
      columns: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.name'),
          field: 'currency_unit',
          tooltipField: 'currency_unit',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.basis'),
          field: 'basis',
          tooltipField: 'basis',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.devideBasis'),
          field: 'devide_basis',
          tooltipField: 'devide_basis',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 250
        },
        {
          headerName: this.$t('grid.column.decimalDigit'),
          field: 'decimal_digit',
          field: 'decimal_digit'
        },
        {
          headerName: this.$t('grid.column.exchangeRate'),
          field: 'exchange_rate',
          field: 'exchange_rate'
        }
      ],
      decimalDigitOptions: [
        {
          label: '0',
          value: '0'
        },
        {
          label: '1',
          value: '1'
        },
        {
          label: '2',
          value: '2'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      currencyItem: {
        code: '',
        decimal_digit: 0,
        currency_unit: '',
        exchange_rate: 0,
        exchange_rate_debit: 0,
        basis: true,
        devide_basis: true
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    async downloadExcel() {
      bus.$emit('startLoader', { msg: '' })
      await getMaterialCurrencyListApi()
        .then(res => {
          downloadFile(res, 'list_currency.xlsx')
          this.$message({
            type: 'success',
            message: this.$t('successMsg.downloadSuccessful')
          })
        })
        .catch(err => {
          this.$message({
            type: 'success',
            message: this.$t('errorMsg.downloadError')
          })
          console.log(err)
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    resetInfo() {
      this.isEdit = false
      this.currencyItem = {
        code: '',
        decimal_digit: 0,
        currency_unit: '',
        exchange_rate: 0,
        exchange_rate_debit: 0,
        basis: true,
        devide_basis: true
      }
    },
    async addCurrency() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addCurrencyApi(this.currencyItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editCurrency() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (row.id == null) {
        this.$alert('Vui lòng chọn loại tiền tệ', 'Error', {
          confirmButtonText: 'OK'
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.currencyItem, row)
    },
    async deleteCurrency() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteCurrencyConfirm'), () => {
          deleteCurrencyApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async updateCurrency() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateCurrencyApi(this.currencyItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListCurrencyApi()
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
// .header {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }
</style>
